import { apiSlice } from "../../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["School"],
});

export const schoolApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getSchoolProfile: builder.query({
      query: () => `/school/profile`,
      providesTags: ["School"],
    }),
    getMySchools: builder.query({
      query: () => `/school/mine`,
      providesTags: ["School"],
    }),
    getSchoolAgent: builder.query({
      query: () => `/school/agent`,
      providesTags: ["School"],
    }),

    updateSchoolProfile: builder.mutation({
      query: (values) => ({
        url: "/school/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["School"],
    }),
    setRecordingDeadline: builder.mutation({
      query: (values) => ({
        url: "/school/recording-deadline",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["School"],
    }),
    clearRecordingDeadline: builder.mutation({
      query: () => ({
        url: "/school/recording-deadline",
        method: "DELETE",
      }),
      invalidatesTags: ["School"],
    }),
  }),
});

export const {
  useGetSchoolProfileQuery,
  useGetMySchoolsQuery,
  useGetSchoolAgentQuery,
  useUpdateSchoolProfileMutation,
  useSetRecordingDeadlineMutation,
  useClearRecordingDeadlineMutation,
} = schoolApiSlice;
